import { Component, HostBinding, Input, OnInit, SimpleChanges, OnChanges, AfterViewInit } from '@angular/core';
import { Component as BrComponent, Content, Menu, Page } from '@bloomreach/spa-sdk';
import { getMenus, getModelFromRef } from '@utils/pagemodel-utils';
import {Constant} from 'src/app/ft-constants/constant';
@Component({
  selector: 'ft-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit {
  @Input() component!: BrComponent;
  @Input() page: Page;
  menu: Content;
  menuModel: Menu;
  readonly ONETRUST_HOOK = Constant.ONETRUST_HOOK;
  readonly ONETRUST_HOOK_CLASS = Constant.ONETRUST_HOOK_CLASS;
  @HostBinding('class') class = 'navbar-nav col-12';
  public oneTrustHook = this.ONETRUST_HOOK;
  public oneTrustHookClass = this.ONETRUST_HOOK_CLASS

  ngOnInit() {
    this.menu = getModelFromRef(this.page, this.component, 'menu');
    this.menuModel = getMenus(this.page, this.component);
  }

  get document() {
    const { document } = this.component?.getModels<DocumentModels>() || {};
    const content = document && this.page?.getContent<Document>(document);
    return content;
  }

  get isPreview() {
    return this.page?.isPreview();
  }

  get footerMenuItems() {
    const items = this.menuModel?.siteMenuItems || [];
    return [...items];
  }
}
